import { MemberCorpoPayload } from 'domain/entities/UserEntity';
import { AppProps } from 'presentation/App';
import { PageTitle } from 'presentation/components/PageTitle';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ConfirmForm } from './components/ConfirmForm';

const CU00701Page = (props: AppProps) => {
    const navigate = useNavigate();
    const location = useLocation();

    const [data, setData] = React.useState<MemberCorpoPayload>();
    const [mode, setMode] = React.useState<'create' | 'edit'>('create');

    const { userUseCase } = props;

    useEffect(() => {
        const stateData = location.state?.data;
        const stateMode = location.state?.mode;
        if (stateMode) {
            setMode(stateMode);
        }
        if (stateData) {
            setData(stateData);
        } else {
            navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.CU_006_01, { replace: true });
        }
    }, []);

    return (
        <div
            style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
            }}
            className="CU-006-01-container"
        >
            <PageTitle title="基本情報の登録" />
            <section>
                <div
                    id="top-form"
                    className="corpo-form-container w-full"
                    style={{ margin: '0 auto' }}
                >
                    <div className="section-wrapper">
                        <ConfirmForm data={data} userUseCase={userUseCase} mode={mode} />
                    </div>
                </div>
            </section>
        </div>
    );
};

export default CU00701Page;
